
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import observaciones from './resumen-observaciones.vue';
    import totales from './resumen-totales.vue';
    import preguntas_ml from './resumen-preguntas-ml.vue';
    import chat_ml from './resumen-chat-ml.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            observaciones,
            totales,
            chat_ml,
            preguntas_ml,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Envio() { return this.Controlador.Pedido ? this.Controlador.Pedido.Envio : null; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Abierto: boolean = false;
    }
